import classNames from "classnames";
import useTealiumOnPageLoad from "../utils/tealium";
import useFilters, { searchBodyFromQuery } from "../hooks/useFilters";
import FilterList from "../components/filters/filter-list";
import NewsCardWrapper from "../components/news-card-wrapper.jsx";
import LoadingError from "./loading-error";
import useResourceFetch from "../hooks/queries/useResourceFetch";
import useBreakpoint from "../hooks/useBreakpoint.js";

const News = ({ page: pageContent }) => {
  const [query, setFilterData] = useFilters();
  const isMobile = useBreakpoint(991);
  useTealiumOnPageLoad({ pageType: "Landing", pageSection1: "News" });

  const {
    data: news,
    error,
    isFetching,
    isInitialLoading,
    fetchNextPage,
  } = useResourceFetch({
    body: searchBodyFromQuery({
      ...query,
      orderBy: query?.orderBy
        ? query?.orderBy === "MOST_RELEVANT"
          ? ""
          : query?.orderBy
        : "NEWEST",
      hubContext: "corporate",
    }),
  });

  return error ? (
    <LoadingError />
  ) : (
    <main className={classNames("page news", isInitialLoading && "loading-skeleton")}>
      <h1 className="loading-highlighted">{pageContent.label}</h1>
      <FilterList
        items={news.data}
        query={query}
        totalCounter={news?.resultsAvailableCount}
        setFilterData={setFilterData}
        facetView={news?.facetView}
        filterColumnOpen={!isMobile}
      >
        <NewsCardWrapper
          news={news}
          pagination={news?.paginationInfo}
          loadMore={fetchNextPage}
          isLoading={isFetching}
        />
      </FilterList>
    </main>
  );
};

export default News;
